jQuery(document).ready(function ($) {
  $('.bbb-posts-items').slick({
    centerMode: false,
    arrows: true,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    variableWidth: true,
    prevArrow:
      '<button class="slick-prev red" aria-label="Previous" type="button"></button>',
    nextArrow:
      '<button class="slick-next red" aria-label="Next" type="button"></button>',
    responsive: [
      {
        breakpoint: 99999,
        settings: {
          slidesToShow: 4,
          variableWidth: false,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          variableWidth: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        },
      },
    ],
  });
});
